module.exports = __webpack_public_path__ + "img/rogerio.943d74d7.jpg";